import { Link } from "react-router-dom";
import { X, Globe } from "lucide-react";

export function MobileMenu({ open, setOpen, links, user, logout, navigate, lang, setLang, t }) {
    if (!open) return null;
    const close = () => setOpen(false);
    return (
        <div className="fixed inset-0 z-50 bg-bone flex flex-col" data-testid="mobile-menu">
            <div className="flex items-center justify-between h-20 px-6 border-b border-espresso/10">
                <img src="/brand-logo.png?v=4" alt="Wild Coffee Retreat" className="h-12 w-auto" />
                <button onClick={close} data-testid="mobile-menu-close"><X size={24} /></button>
            </div>
            <nav className="flex flex-col px-6 py-8 gap-6">
                {links.map((l) => (
                    <Link key={l.key} to={l.to} onClick={close} data-testid={`mobile-nav-${l.key}`} className="font-serif text-3xl">{l.label}</Link>
                ))}
                <div className="hairline my-4" />
                <div className="flex items-center gap-3 text-xs uppercase tracking-widest2" data-testid="mobile-lang-toggle">
                    <Globe size={14} />
                    <button onClick={() => setLang("en")} data-testid="mobile-lang-en" className={lang === "en" ? "text-forest" : "text-muted2"}>EN</button>
                    <span className="text-espresso/30">·</span>
                    <button onClick={() => setLang("es")} data-testid="mobile-lang-es" className={lang === "es" ? "text-forest" : "text-muted2"}>ES</button>
                </div>
                {user ? (
                    <>
                        <Link to="/dashboard" onClick={close} data-testid="mobile-my-stay" className="font-sans text-sm uppercase tracking-widest2">{t("nav.myReservations")}</Link>
                        <Link to="/profile" onClick={close} data-testid="mobile-profile" className="font-sans text-sm uppercase tracking-widest2">{t("nav.profile")}</Link>
                        {user.role === "admin" && (
                            <Link to="/admin" onClick={close} data-testid="mobile-admin" className="font-sans text-sm uppercase tracking-widest2">{t("nav.adminDashboard")}</Link>
                        )}
                        <button onClick={async () => { await logout(); close(); navigate("/"); }} data-testid="mobile-logout" className="text-left font-sans text-sm uppercase tracking-widest2">{t("nav.signOut")}</button>
                    </>
                ) : (
                    <Link to="/login" onClick={close} data-testid="mobile-signin" className="font-sans text-sm uppercase tracking-widest2">{t("nav.signIn")}</Link>
                )}
                <Link to="/book" onClick={close} data-testid="mobile-reserve" className="mt-4 inline-block text-center font-sans text-xs uppercase tracking-widest2 px-6 py-4 bg-forest text-bone">
                    {t("nav.reserve")}
                </Link>
            </nav>
        </div>
    );
}
